
import React from 'react';
import ReactDOM from 'react-dom/client';

import { endpoints } from './shared/config'
import { Config, DAppProvider, Mainnet, Goerli, ChainId, MetamaskConnector, CoinbaseWalletConnector, Connector } from '@usedapp/core';
import { WalletConnectV2Connector } from '@usedapp/wallet-connect-v2-connector'
import App from './App';

const supportedChainId : any = endpoints.chainId;
const wcRpcMap : Record<string, string> = {};
wcRpcMap[supportedChainId] = endpoints.rpcUrl;

const config: Config = {
  readOnlyChainId: supportedChainId,
  readOnlyUrls: {
    [supportedChainId]: endpoints.rpcUrl
  },
  connectors: {
    metamask: new MetamaskConnector(),
    coinbase: new CoinbaseWalletConnector(),
    walletConnectV2: new WalletConnectV2Connector({
      projectId: '07578a352cc11e370b33eac1653d1b82',
      chains: [supportedChainId === ChainId.Goerli ? Goerli: Mainnet],
      rpcMap: wcRpcMap
    }) as Connector
    
  },
  multicallVersion: 2,
  pollingInterval: 12100,
  refresh: 'everyBlock'
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  <React.StrictMode>
    <DAppProvider config={config}>
      <App supportedChainId={supportedChainId}/>
    </DAppProvider>
  </React.StrictMode>
);